import { render, staticRenderFns } from "./editCover.vue?vue&type=template&id=1c511fe4&scoped=true"
import script from "./editCover.vue?vue&type=script&lang=js"
export * from "./editCover.vue?vue&type=script&lang=js"
import style0 from "./editCover.vue?vue&type=style&index=0&id=1c511fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c511fe4",
  null
  
)

export default component.exports